import { IS_TOGGLE } from "../actions/ToggleAction";

const initialState = {
  Clicked: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case IS_TOGGLE:
      return {
        ...state,
        Clicked: action.payload,
      };
   
    default:
      return state;
  }
};